"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.execute = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _UpdateNotificationsService = require("../service/UpdateNotificationsService");

var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * The function will toggle the read status of
 * a particular notification and return if the status
 * is successful or not.
 * @param notification
 */
var execute = function execute(notification) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var queryObject, _ref2, notifications;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: types.TOGGLE_NOTIFICATION_READ_STATUS,
                  payload: {
                    id: notification.id
                  }
                });
                queryObject = _PulseApiHelper.default.createANSResponseObject(_objectSpread({}, notification, {
                  isRead: !notification.isRead
                }));
                _context.next = 4;
                return (0, _UpdateNotificationsService.updateNotifications)([queryObject]);

              case 4:
                _ref2 = _context.sent;
                notifications = _ref2.notification;

                if (notifications.length !== 1) {
                  dispatch({
                    type: types.TOGGLE_NOTIFICATION_READ_STATUS,
                    payload: {
                      id: notification.id
                    }
                  });
                }

                return _context.abrupt("return", notifications.length === 1);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.execute = execute;
var _default = execute;
exports.default = _default;